import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayMode } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  CodeConversionMstDto, Sgke401aRequest, Sgke401aResponseResponseCndtAuthorityList,
  Sgke402aRequest, Sgke402aResponseLossReasonList, Sgke402aResponseLossyoteiChargeKeylst, Sgke402aResponseSearchresultList,
  Sgke403aRequest, Sgke403aRequestLossyoteiChargeInformationlist, Sgke403aRequestLossyoteiChargeKeylst,
  Sgke404aRequest, Sgke404aRequestLossInfoList, Sgke404aRequestLossyoteiChargeKeylst,
  Sgke903aRequest, Sgke903aResponseCompanyAreaInfo, Sgke903aResponseInitialhyojiInfo
} from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { UsedSgke401aService } from '../../../../../sg-ke-shared/services/used-sgke401a.service';
import { UsedSgke404aService } from '../../../../../sg-ke-shared/services/used-sgke404a.service';
import { UsedSgke903aService } from '../../../../../sg-ke-shared/services/used-sgke903a.service';
import { Sgke400dResultComponent } from '../../components/sgke400d-result/sgke400d-result.component';
import { Sgke400dResultDto } from '../../components/sgke400d-result/sgke400d-result.dto';
import { UsedSgke402aService } from '../../services/used-sgke402a.service';
import { UsedSgke403aService } from '../../services/used-sgke403a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke400d',
  templateUrl: './sgke400d.component.html',
  styleUrl: './sgke400d.component.scss'
})
export class Sgke400dComponent implements OnInit, OnDestroy {

  @ViewChild(Sgke400dResultComponent)
  public sgke400dResultComponent!: Sgke400dResultComponent;

  /** 画面ID */
  private static GAMEN_ID = 'SGKE400D';

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** モード区分_登録 */
  public MODE_CREATE = DisplayMode.create;
  /** モード区分_承認 */
  public MODE_APPROVE = DisplayMode.approve;

  /** 欠損予定ステータス_欠損判定依頼 */
  public LOSSYOTEI_STS_CODE_REQUEST_JUDGMENT = '02';
  /** 欠損予定ステータス_各社承認済 */
  public LOSSYOTEI_STS_CODE_APPROVED_BY_ALL_COMPANIES = '04';
  /** 欠損予定ステータス_最終承認済 */
  public LOSSYOTEI_STS_CODE_FINAL_APPROVAL = '05';


  /** モード区分（初期値として登録を設定） */
  mode: string = this.MODE_CREATE;
  /** 検索APIリクエスト情報 FormGroup */
  searchCndtFormGroup: UntypedFormGroup;
  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();
  /** コード変換マスタマップ */
  codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;
  /** 検索条件権限リスト */
  cndtAuthorityList: Array<Sgke401aResponseResponseCndtAuthorityList>;
  /** 会社地区情報 */
  cmpnyAreaList: Array<Sgke903aResponseCompanyAreaInfo>;
  /** 会社地区初期表示情報 */
  cmpnyAreaInit: Sgke903aResponseInitialhyojiInfo;
  /** 検索結果リスト */
  searchresultList: Array<Sgke402aResponseSearchresultList> = new Array<Sgke402aResponseSearchresultList>();
  /** 欠損理由リスト */
  lossReasonList: Array<Sgke402aResponseLossReasonList>;

  /** 検索APIリクエスト */
  requestSgke402a: Sgke402aRequest;

  /**
   * コンストラクタ
   * @param {ActivatedRoute} route
   * @param {Router} router 
   * @param {UsedSgke903aService} companyAreaInfoService
   * @param {UsedSgke401aService} initService
   * @param {UsedSgke402aService} searchService
   * @param {UsedSgke403aService} registrationService
   * @param {UsedSgke404aService} downloadService
   * @param {CodeConversionMstService} codeConversionMstService
   * @param {UntypedFormBuilder} fb
   * @param {ChangeDetectorRef} cd
   * @param {ResponseMsgUtils} responseMsgUtils
   * @memberof Sgke400dComponent
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private companyAreaInfoService: UsedSgke903aService,
    public initService: UsedSgke401aService,
    public searchService: UsedSgke402aService,
    public registrationService: UsedSgke403aService,
    public downloadService: UsedSgke404aService,
    private codeConversionMstService: CodeConversionMstService,
    private fb: UntypedFormBuilder,
    private cd: ChangeDetectorRef,
    private responseMsgUtils: ResponseMsgUtils,
  ) { }

  /**
   * 初期処理
   * @returns {void}
   * @memberof Sgke400dComponent
   */
  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {

      // 画面遷移元パラメータ取得
      this.mode = params.get('mode');
      // 検索条件Formを初期化
      this.searchCndtFormGroup = this.fb.group({
        requestCommon: new UntypedFormGroup({}),
      });

      // クリア処理
      this.clear();
      this.cmpnyAreaList = null;
      this.codeConversionMstMap = null;
      this.cndtAuthorityList = null;

      //コード変換マスタ共通コンポーネント呼び出し
      this.codeConversionMstService.getCodeConversionMst([
        'S300090',
        'S300620',
      ])
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(data => {
          // ローカルに保存
          this.codeConversionMstMap = data;
        });

      // 初期表示呼出し処理
      this.init();
      // 会社地区情報取得
      this.getCompanyAreaInfo();

    });

  }

  /**
   * 購読解除
   * @returns {void}
   * @memberof Sgke400dComponent
   */
  ngOnDestroy(): void {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * 検索処理
   * @public
   * @param {boolean} [isFromSearchBtn=true]
   * @returns {void}
   * @memberof Sgke400dComponent
   */
  public search(isFromSearchBtn: boolean = true): void {

    // 検索結果リスト初期化
    this.searchresultList.length = 0;

    if (isFromSearchBtn) {
      // メッセージクリア
      // this.clearErrorMsg();
      this.errorMessageModelArray = new Array<SgAriaMessage>();
      this.cd.detectChanges();

      // 活性状態の値を取得
      this.requestSgke402a = this.searchCndtFormGroup.getRawValue() as Sgke402aRequest;
    }

    // SGKE402A呼び出し
    this.searchService.doSgke402a(this.requestSgke402a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        if (response?.shtkInfo?.searchresultList) {
          this.searchresultList = response.shtkInfo.searchresultList;
          this.lossReasonList = response.shtkInfo.lossReasonList;
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
        error => {
        });
  }

  /**
   * 請求ポータル画面への遷移
   * @public
   * @param {Sgke402aResponseSearchresultList} row
   * @returns {void}
   * @memberof Sgke400dComponent
   */
  public navigateBill(row: Sgke402aResponseSearchresultList): void {
    // 受付基盤UIのURL取得
    const url: string = (window as any).__env.ACEPTBASE_UI_BASE_PATH;
    // anyタイプのパラメータ
    let paramToOutside: any = {};
    // お客さま番号
    let customerNo: string = row.visitornumber;
    // 支払契約番号
    let paymentContractNo: string = row.payCtrNo;

    // パラメータ設定
    // お客さま番号
    if (customerNo) {
      paramToOutside.c__customerNo = customerNo;
    }
    // 支払契約番号
    if (paymentContractNo) {
      paramToOutside.c__paymentContractNo = paymentContractNo;
    }
    // 起動元画面
    paramToOutside.c__launchSourceScreen = '9';

    //  anyタイプをクエリ文字列に変換
    let params: string = new URLSearchParams(paramToOutside).toString();
    if (params) {
      params = '?' + params;
    };

    // 別タブで該当URLを開く
    window.open(`${url}${params}`, '_blank');
  }

  /**
   * 登録処理
   * @public
   * @param {Sgke400dResultDto[]} selected
   * @returns {void}
   * @memberof Sgke400dComponent
   */
  public register(selected: Sgke400dResultDto[]): void {
    // メッセージクリア
    this.clearErrorMsg();
    // 欠損予定料金キーリスト 生成関数
    let lossyoteiChargeKeylstFunc = function (row: Sgke402aResponseLossyoteiChargeKeylst): Sgke403aRequestLossyoteiChargeKeylst {
      return {
        cdtmnyNo: row.cdtmnyNo,
        cdtmnyRrkno: row.cdtmnyRrkno,
        updateSrno: row.updateSrno,
      };
    }

    // 欠損予定料金情報リスト
    let lossyoteiChargeInformationlistFunc = function (row: Sgke400dResultDto): Sgke403aRequestLossyoteiChargeInformationlist {
      return {
        // 欠損予定料金キーリスト
        lossyoteiChargeKeylst: row.lossyoteiChargeKeylst.map(lossyoteiChargeKeylstFunc),
        // 欠損予定ステータスコード
        lossyoteiStsCode: row.lossyoteiStsCode,
        // 請求お客さま番号
        recptFixNo: row.payCtrNo,
        // 料金区分コード
        chargeDivcd: row.chargeDivcd,
        // 欠損理由コード
        lossRsncod: row.lossRsncod,
        // チェック付与の場合、true,チェック解除の場合false
        lossreqestTargetflag: row.checked,
      };
    }

    // 登録リクエストDTO作成
    let request: Sgke403aRequest = {
      requestCommon: null,
      reqBusinessArea: {
        // 欠損予定料金情報リスト
        lossyoteiChargeInformationlist: selected.map(lossyoteiChargeInformationlistFunc),
        // 承認画面フラグ 欠損予定一覧モードのためfalseを設定
        apprvGamenFlg: false
      }
    }

    // SGKE403A呼び出し
    this.registrationService.doSgke403a(request).pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleRegistResponse,
        this.handleError,
      );

  }

  /**
   * 承認処理
   * @public
   * @param {Sgke402aResponseSearchresultList[]} selected
   * @returns {void}
   * @memberof Sgke400dComponent
   */
  public approve(selected: Sgke402aResponseSearchresultList[]): void {
    // メッセージクリア
    this.clearErrorMsg();
    // 欠損予定料金キーリスト 生成関数
    let lossyoteiChargeKeylstFunc = function (row: Sgke402aResponseLossyoteiChargeKeylst): Sgke403aRequestLossyoteiChargeKeylst {
      return {
        cdtmnyNo: row.cdtmnyNo,
        cdtmnyRrkno: row.cdtmnyRrkno,
        updateSrno: row.updateSrno,
      };
    }

    // 欠損予定料金情報リスト
    let lossyoteiChargeInformationlistFunc = function (row: Sgke402aResponseSearchresultList): Sgke403aRequestLossyoteiChargeInformationlist {
      return {
        // 欠損予定料金キーリスト
        lossyoteiChargeKeylst: row.lossyoteiChargeKeylst.map(lossyoteiChargeKeylstFunc),
        // 欠損予定ステータスコード
        lossyoteiStsCode: row.lossyoteiStsCode,
        // 請求お客さま番号
        recptFixNo: row.payCtrNo,
        // 料金区分コード
        chargeDivcd: row.chargeDivcd,
        // 欠損理由コード
        lossRsncod: row.lossRsncod,
        // 欠損依頼対象フラグ※承認の場合はチェック付与されている行が対象のためtrueを設定
        lossreqestTargetflag: true,
      };
    }

    // 承認リクエストDTO作成
    let request: Sgke403aRequest = {
      requestCommon: null,
      reqBusinessArea: {
        // 欠損予定料金情報リスト
        lossyoteiChargeInformationlist: selected.map(lossyoteiChargeInformationlistFunc),
        // 承認画面フラグ 承認のためtrueを設定
        apprvGamenFlg: true
      }
    }

    // SGKE403A呼び出し
    this.registrationService.doSgke403a(request).pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleRegistResponse,
        this.handleError,
      );
  }

  /**
   * クリア処理
   * @public
   * @returns {void}
   * @memberof Sgke400dComponent
   */
  public clear(): void {
    // メッセージクリア
    this.clearErrorMsg();
    // 検索結果リスト初期化
    this.searchresultList.length = 0;
  }

  /**
   * ダウンロード処理
   * @public
   * @param {Sgke400dResultDto[]} filtered
   * @returns {void}
   * @memberof Sgke400dComponent
   */
  public download(filtered: Sgke400dResultDto[]): void {
    // エラーメッセージクリア
    this.clearErrorMsg();

    // 子オブジェクト生成関数
    let lossyoteiChargeKeylstFunc = function (childRow: Sgke402aResponseLossyoteiChargeKeylst): Sgke404aRequestLossyoteiChargeKeylst {
      return {
        cdtmnyNo: childRow.cdtmnyNo,
        cdtmnyRrkno: childRow.cdtmnyRrkno,
        updateSrno: childRow.updateSrno
      };
    }

    // オブジェクト生成関数
    let lossInfoListFunc = function (row: Sgke400dResultDto): Sgke404aRequestLossInfoList {
      return {
        lossyoteiChargeKeylst: row.lossyoteiChargeKeylst.map(lossyoteiChargeKeylstFunc)
      };
    }
    // pdf出力リクエスト情報をもつオブジェクトを定義
    let requestSgke404a: Sgke404aRequest = {
      requestCommon: null,
      lossInfoList: filtered.map(lossInfoListFunc),
      lossyoteiStsCode: this.LOSSYOTEI_STS_CODE_APPROVED_BY_ALL_COMPANIES,
    };

    // SGKE404A呼び出し
    this.downloadService.doSgke404a(requestSgke404a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
      error => {
      }
    );
  }

  /**
   * SGKE903A_会社地区情報取得API呼出し
   * @private
   * @returns {void}
   * @memberof Sgke400dComponent
   */
  private getCompanyAreaInfo(): void {
    let requestInfo: Sgke903aRequest = {
      requestCommon: null,
      reqBusinessArea: {
        gamenId: Sgke400dComponent.GAMEN_ID
      }
    };

    this.companyAreaInfoService.doSgke903a(requestInfo).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response.responseBusinessArea) {
          this.cmpnyAreaList = response?.responseBusinessArea.companyAreaInformationlist;
          this.cmpnyAreaInit = response?.responseBusinessArea.initialhyojiInfo;
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
      error => {
      });

  }

  /**
   * 初期表示API呼び出し
   * @private
   * @returns {void}
   * @memberof Sgke400dComponent
   */
  private init(): void {

    // Formの内容をリクエストに設定
    let request: Sgke401aRequest = {
      requestCommon: null,
      requestCustomize: {
        // SGKE400Dから呼び出す場合はfalseを設定
        apprvGamenFlg: false,
      },

    };

    //SGKE401A_欠損承認依頼・最終承認初期表示API呼び出し
    this.initService.doSgke401a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          if (response?.responseBusinessArea?.cndtAuthorityList) {
            this.cndtAuthorityList = response.responseBusinessArea.cndtAuthorityList;
          }
          // メッセージを表示
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
        },
        error => {
        });
  }

  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @returns {void}
   * @memberof Sgke400dComponent
   */
  private clearErrorMsg(): void {
    this.errorMessageModelArray.length = 0;
  }

  /**
   * レスポンス共通処理
   * @private
   * @param {any} response
   * @return  {void}
   * @memberof Sgke400dComponent
   */
  private handleRegistResponse = (response: any): void => {
    if (response) {
      // メッセージを表示
      this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);

      // 一覧を再検索
      this.search(false);
    }
  }

  /**
   * エラー共通処理
   * @private
   * @param {any} error
   * @returns {void}
   * @memberof Sgke400dComponent
   */
  private handleError = (error: any): void => {
  }

}
